"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1437],{

/***/ 15445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var Link = __webpack_require__(504);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./public/dawn-logo.svg
var dawn_logo = __webpack_require__(54171);
// EXTERNAL MODULE: ./components/icons/IconFacebook.tsx
var IconFacebook = __webpack_require__(12337);
// EXTERNAL MODULE: ./components/icons/IconTwitter.tsx
var IconTwitter = __webpack_require__(22971);
;// CONCATENATED MODULE: ./components/icons/IconInstagram.tsx

function IconInstagram(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        viewBox: "0 0 24 24",
        className: "fill-current ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.053.072C8.333.013 8.74 0 12 0s3.668.014 4.946.072c1.279.058 2.151.262 2.915.557.8.303 1.525.775 2.125 1.386a5.862 5.862 0 011.383 2.124c.297.764.5 1.636.559 2.913C23.987 8.333 24 8.742 24 12c0 3.26-.014 3.668-.072 4.947-.058 1.277-.262 2.15-.559 2.913a5.887 5.887 0 01-1.383 2.126 5.885 5.885 0 01-2.125 1.383c-.764.297-1.636.5-2.913.559-1.28.059-1.688.072-4.948.072-3.26 0-3.668-.014-4.947-.072-1.277-.058-2.15-.262-2.913-.559a5.889 5.889 0 01-2.126-1.383 5.882 5.882 0 01-1.385-2.125c-.295-.764-.498-1.636-.557-2.913C.013 15.666 0 15.258 0 12c0-3.26.014-3.668.072-4.946.058-1.279.262-2.151.557-2.915.302-.8.775-1.526 1.386-2.125A5.882 5.882 0 014.139.629C4.903.334 5.775.131 7.052.072zm9.796 2.16c-1.265-.058-1.645-.07-4.849-.07s-3.584.012-4.85.07c-1.17.053-1.805.249-2.228.413-.56.219-.96.477-1.38.897a3.722 3.722 0 00-.897 1.38c-.164.423-.36 1.058-.413 2.229-.058 1.265-.07 1.645-.07 4.849s.012 3.584.07 4.85c.053 1.17.249 1.804.413 2.228.192.52.499.992.897 1.38.387.398.86.705 1.38.897.423.164 1.058.36 2.229.413 1.265.058 1.644.07 4.849.07s3.584-.012 4.85-.07c1.17-.053 1.804-.249 2.228-.413.56-.219.96-.477 1.38-.897.398-.387.705-.86.897-1.38.164-.424.36-1.058.413-2.229.058-1.265.07-1.645.07-4.849s-.012-3.584-.07-4.85c-.053-1.17-.249-1.805-.413-2.228a3.725 3.725 0 00-.897-1.38 3.723 3.723 0 00-1.38-.897c-.424-.164-1.058-.36-2.229-.413zm-6.382 13.467a4.002 4.002 0 004.364-6.53 4.003 4.003 0 10-4.364 6.53zM7.64 7.64a6.168 6.168 0 118.722 8.722A6.168 6.168 0 017.64 7.64zm11.897-.888a1.458 1.458 0 10-2-2.121 1.458 1.458 0 002 2.12z",
            fill: "#fff"
        })
    });
};

;// CONCATENATED MODULE: ./components/Footer/Footer.tsx








function Footer(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: classnames_default()("flex justify-center border-t border-white border-opacity-10", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center flex-1 px-10 py-8 max-w-9xl xl:flex-row xl:justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center xl:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-24 xl:mr-14",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    "aria-label": "Back to main page",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: dawn_logo/* default */.Z,
                                        alt: "Dawn logo"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center flex-1 mt-8 space-y-8 text-sm leading-4 xl:text-base xl:flex-row xl:space-y-0 xl:space-x-14 xl:mt-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "/legal/terms-of-service",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "font-medium tracking-widest text-white uppercase",
                                        children: "Terms"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "/legal/privacy-policy",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "font-medium tracking-widest text-white uppercase",
                                        children: "Privacy"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "https://www.notion.so/dawn-health/Dawn-Job-Board-c370eab65ee14522a716bc8fcbedd213",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "font-medium tracking-widest text-white uppercase",
                                        children: "Jobs"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:team@dawn.health",
                                    className: "font-medium tracking-widest text-white uppercase",
                                    children: "Contact"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#",
                                    className: "font-medium tracking-widest uppercase text-dawnDark-200",
                                    children: "\xa9 2023 Sleepedy, Inc"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center mt-6 space-x-12 text-white xl:mt-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "https://www.facebook.com/dawnhealthapp",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "aria-label": "Facebook",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFacebook/* default */.Z, {
                                    className: "w-6 h-6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "https://twitter.com/dawnhealthapp",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "aria-label": "Twitter",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTwitter/* default */.Z, {
                                    className: "w-6 h-6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "https://www.instagram.com/dawnhealthapp/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "aria-label": "Instagram",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconInstagram, {
                                    className: "w-6 h-6"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 1824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ Gradient; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/tailwindConfig.ts
var tailwindConfig = __webpack_require__(30049);
;// CONCATENATED MODULE: ./components/Gradient/Gradient.tsx


var tailwindColors = tailwindConfig/* theme */.r === null || tailwindConfig/* theme */.r === void 0 ? void 0 : tailwindConfig/* theme.colors */.r.colors;
var availableColors = {
    purple: tailwindColors["dawnPurple"]["500"],
    orange: tailwindColors["dawnOrange"]["500"]
};
function Gradient(param) {
    var color = param.color, _scale = param.scale, scale = _scale === void 0 ? 1 : _scale, _opacity = param.opacity, opacity = _opacity === void 0 ? 0.15 : _opacity, _right = param.right, right = _right === void 0 ? undefined : _right, _left = param.left, left = _left === void 0 ? undefined : _left, _top = param.top, top = _top === void 0 ? 0 : _top, _fixed = param.fixed, fixed = _fixed === void 0 ? false : _fixed;
    var width = 200;
    var height = 100;
    var selectedColor = availableColors[color];
    width = width * scale;
    height = height * scale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        style: {
            right: right,
            left: left,
            top: top
        },
        className: "".concat(fixed ? "fixed" : "absolute", "  z-0 overflow-hidden"),
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                filter: "url(#filter)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                    cx: "50%",
                    cy: "50%",
                    rx: "20%",
                    ry: "20%",
                    fill: selectedColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter",
                    x: "0",
                    y: "0",
                    width: width,
                    height: height,
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: Math.round(width * 0.07),
                            result: "effect1_foregroundBlur"
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Gradient/index.ts



/***/ }),

/***/ 34639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuestionnaireCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function QuestionnaireCTA(param) {
    var buttonText = param.buttonText, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/questionnaire",
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "flex items-center justify-center flex-1 max-w-md font-medium md:flex-none  px-10 py-4 text-sm tracking-widest text-center text-white uppercase rounded-full getStartedSleepIssues md:py-5 md:self-start bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 md:text-base"),
            children: buttonText || "Get Started"
        })
    });
};


/***/ }),

/***/ 12337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconFacebook; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function IconFacebook(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 24 24",
        className: "fill-current ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"
        })
    });
};


/***/ }),

/***/ 22971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconTwitter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function IconTwitter(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 24 24",
        className: "fill-current ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"
        })
    });
};


/***/ }),

/***/ 31437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ CallToAction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(15445);
// EXTERNAL MODULE: ./components/QuestionnaireCTA/QuestionnaireCTA.tsx
var QuestionnaireCTA = __webpack_require__(34639);
;// CONCATENATED MODULE: ./components/page-sections/CallToAction/CallToAction.tsx




function CallToAction(param) {
    var title = param.title, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden text-white bg-dawnDark-700",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.15,
                        left: "-50rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 8,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.1,
                        right: "-55rem",
                        top: "0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.12,
                        right: "-47rem",
                        top: "3rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "flex justify-center py-22 md:py-24",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full max-w-4xl mx-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-5xl leading-14 font-semibold md:text-5.5xl md:leading-18 text-center",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-4 mx-auto max-w-1.5xl text-base leading-6 text-center md:text-xl md:leading-8",
                                    children: text
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex justify-center mt-7",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionnaireCTA/* default */.Z, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/CallToAction/index.ts



/***/ }),

/***/ 41125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var _object_spread = (__webpack_require__(50337)/* ["default"] */ .Z);
var _to_consumable_array = (__webpack_require__(53929)/* ["default"] */ .Z);
var defaultTheme = __webpack_require__(75874);
module.exports = {
    purge: [
        "./pages/**/*.{js,ts,jsx,tsx}",
        "./modules/**/*.{js,ts,jsx,tsx}",
        "./lib/**/*.{js,ts,jsx,tsx}",
        "./components/**/*.{js,ts,jsx,tsx}", 
    ],
    mode: "jit",
    darkMode: false,
    theme: {
        linearBorderGradients: function(theme) {
            return {
                colors: _object_spread({
                    "orange-purple": [
                        theme("colors.dawnOrange.500"),
                        theme("colors.dawnPurple.500")
                    ]
                }, theme("colors")),
                background: _object_spread({
                    white: theme("colors.white")
                }, theme("colors"))
            };
        },
        colors: {
            dawnDark: {
                100: "#EFF2F6",
                150: "#E5E5E5",
                200: "#BBBDC5",
                300: "#858992",
                400: "#4F555F",
                500: "#19212C",
                550: "#232832",
                600: "#151B25",
                700: "#11161E",
                800: "#0D1117",
                900: "#090C10"
            },
            dawnOrange: {
                100: "#FFEEE5",
                200: "#FFD7C4",
                300: "#FFBFA1",
                400: "#FFA77E",
                500: "#FF8F5B",
                600: "#C56E45",
                700: "#8C4C2E",
                800: "#532A17",
                900: "#1A0800"
            },
            dawnPurple: {
                100: "#E9EDFB",
                200: "#C5CDF4",
                300: "#9FADEE",
                400: "#798DE8",
                500: "#536DE2",
                600: "#4055AF",
                700: "#2C3B7C",
                800: "#182149",
                900: "#040716"
            },
            dawnRed: {
                500: "#E24328"
            },
            dawnGreen: {
                500: "#E24328"
            },
            white: "#fff",
            black: "#000",
            transparent: "transparent"
        },
        extend: {
            spacing: {
                1.5: "0.375rem",
                13: "3.25rem",
                18: "4.5rem",
                22: "5.5rem",
                26: "6.5rem",
                30: "7.5rem",
                34: "8.5rem",
                38: "9.5rem",
                62: "15.5rem",
                100: "25rem",
                108: "27rem",
                500: "31.25rem"
            },
            maxWidth: {
                "1.5xl": "38rem",
                "3.5xl": "52rem",
                "8xl": "88rem",
                "9xl": "96rem"
            },
            fontFamily: {
                sans: [
                    "Epilogue"
                ].concat(_to_consumable_array(defaultTheme.fontFamily.sans)),
                inter: [
                    "Inter"
                ].concat(_to_consumable_array(defaultTheme.fontFamily.sans))
            },
            fontSize: {
                "2.5xl": "1.75rem",
                "3.5xl": "2rem",
                "5.5xl": "3.5rem",
                "6.25xl": "4rem"
            },
            lineHeight: {
                12: "3rem",
                14: "3.5rem",
                18: "4.5rem"
            },
            zIndex: {
                "-10": "-10",
                "-05": "-05"
            },
            borderWidth: {
                1.5: "1.5px"
            },
            borderRadius: {
                dawnDefault: "2.5rem"
            },
            inset: {
                "60%": "60%"
            },
            backdropBlur: {
                "1.5xl": "2.25rem"
            },
            opacity: {
                6: "0.06"
            },
            maxHeight: {
                1000: "100rem"
            },
            typography: function(theme) {
                return {
                    DEFAULT: {
                        css: {
                            a: {
                                "word-break": "break-word",
                                "overflow-wrap": "break-word",
                                fontWeight: "normal",
                                "text-decoration": "none",
                                color: theme("colors.dawnPurple.500"),
                                "&:hover": {
                                    color: theme("colors.dawnPurple.600")
                                }
                            }
                        }
                    }
                };
            }
        }
    },
    plugins: [
        __webpack_require__(50130),
        __webpack_require__(54863),
        __webpack_require__(34270),
        __webpack_require__(2112), 
    ]
};


/***/ }),

/***/ 30049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ theme; }
/* harmony export */ });
/* harmony import */ var tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86926);
/* harmony import */ var tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tailwind_config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41125);
/* harmony import */ var _tailwind_config_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tailwind_config_js__WEBPACK_IMPORTED_MODULE_1__);


var theme = tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0___default()((_tailwind_config_js__WEBPACK_IMPORTED_MODULE_1___default())).theme;


/***/ })

}]);